import React from "react";
import SingleCardLeadership from "@qlik/qlik/src/components/Card/SingleCardLeadership";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";

/**
 * LeadershipCard component
 * @param {Object} data - The data for the leadership card.
 */
const LeadershipCard = ({ data }) => {
    const { title, description, cardItems, customId, additionalConfiguration = [] } = data ?? {};
    // Determine if the first row should be rendered
    const renderFirstRow = title || description?.description;

    // Get the class name for the section padding
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "");
    return (
        <section className={`py-12.5 lg:pt-20 lg:pb-5 ${sectionSpacingClassName}`} id={customId}>
            <div className="container">
                {/* Render the first row if it exists */}
                {renderFirstRow && (
                    <div className="row">
                        <div className="col-12 mb-15">
                            {/* Render the title if it exists */}
                            {title && <h2 className="text-left mb-4.75">{title}</h2>}
                            {/* Render the description if it exists */}
                            {description?.description && (
                                <p className="body-big text-left mb-4.75 mt-2.5">{description?.description}</p>
                            )}
                        </div>
                    </div>
                )}
                <div className="row">
                    {/* Map through the card items and render each one */}
                    {cardItems?.map((cardItem) => (
                        <div className="col-12 md:col-4 mb-15" key={cardItem?.components?.[0]?.id}>
                            <SingleCardLeadership
                                image={cardItem?.components?.[0]?.cardItem.media?.[0]}
                                title={cardItem?.components?.[0].cardItem?.title || ""}
                                subtitle={cardItem?.components?.[0].cardItem?.subtitle || []}
                                link={cardItem?.slug || ""}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LeadershipCard;
